  import { ClusterJewelTiers } from "../../models/item-data-models";

export const clusterJewelTiers: ClusterJewelTiers = {
  excellent: [],
  good: [],
}
